import { RubricCategory, SimpleMapping, MappingInsightData } from './mappingTypes';

export const calculateMappingInsights = (
  rubricCategories: RubricCategory[],
  mappings: SimpleMapping[]
): MappingInsightData => {
  const totalCriteria = rubricCategories.reduce((sum, cat) => sum + cat.items.length, 0);
  const mappedCriteria = new Set<string>();
  
  mappings.forEach(m => {
    m.rubricItems.forEach(itemId => {
      mappedCriteria.add(`${m.rubricCategory}-${itemId}`);
    });
  });

  const unmappedCount = totalCriteria - mappedCriteria.size;

  // Find unmapped items
  const unmappedItems: string[] = [];
  rubricCategories.forEach(cat => {
    cat.items.forEach(item => {
      const isMapped = mappings.some(m => 
        m.rubricCategory === cat.id && m.rubricItems.includes(item.id)
      );
      if (!isMapped) {
        unmappedItems.push(item.text);
      }
    });
  });

  return {
    totalCriteria,
    mappedCount: mappedCriteria.size,
    unmappedCount,
    unmappedItems: unmappedItems.slice(0, 2), // Show first 2 unmapped items
    alignmentStatus: unmappedCount === 0 ? 'perfect' : unmappedCount <= 3 ? 'good' : 'needs-work'
  };
};

export const transformMappingsToSimple = (
  mappings: any[],
  mappingType: 'modal' | 'onboarding'
): SimpleMapping[] => {
  if (mappingType === 'modal') {
    // Transform MappingModal format (GoalRubricMapping)
    return mappings.map(m => ({
      goalId: m.goal_id,
      rubricCategory: m.rubric_category,
      rubricItems: m.rubric_items || [] // Handle null rubric_items
    }));
  } else {
    // Transform onboarding format (object with goalId as key)
    const simpleMappings: SimpleMapping[] = [];
    Object.entries(mappings).forEach(([goalId, rubricItems]) => {
      // Group by category
      const itemsByCategory: Record<string, string[]> = {};
      (rubricItems as string[]).forEach(itemId => {
        const [categoryId, itemIndex] = itemId.split('-');
        if (!itemsByCategory[categoryId]) {
          itemsByCategory[categoryId] = [];
        }
        itemsByCategory[categoryId].push(itemIndex);
      });
      
      // Create mappings per category
      Object.entries(itemsByCategory).forEach(([categoryId, items]) => {
        simpleMappings.push({
          goalId,
          rubricCategory: categoryId,
          rubricItems: items
        });
      });
    });
    return simpleMappings;
  }
};